import { render, staticRenderFns } from "./MessagePushDetail.vue?vue&type=template&id=6ea4362a&scoped=true"
import script from "./MessagePushDetail.vue?vue&type=script&lang=js"
export * from "./MessagePushDetail.vue?vue&type=script&lang=js"
import style0 from "./MessagePushDetail.vue?vue&type=style&index=0&id=6ea4362a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea4362a",
  null
  
)

export default component.exports